import { render, staticRenderFns } from "./base-layout.vue?vue&type=template&id=02540e54&scoped=true&"
import script from "./base-layout.vue?vue&type=script&lang=ts&"
export * from "./base-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02540e54",
  null
  
)

export default component.exports